// Add your custom JS here.
jQuery(document).ready(function($) {
    if ( $('.acc_slick_gallery').length > 0 ){
        $('.acc_slick_gallery').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true,
            prevArrow: '#acc_prev_slick_gallery',
            nextArrow: '#acc_next_slick_gallery',
            asNavFor: '.acc_slick_gallery_nav'
        });
        $('.acc_slick_gallery_nav').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.acc_slick_gallery',
            dots: false,
            arrows: false,
            centerMode: false,
            focusOnSelect: true
        });


        const myModalEl = document.getElementById('acc_galery_modal')
        myModalEl.addEventListener('shown.bs.modal', event => {
            $('.acc_gallery_desk').slick({
                dots: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                adaptiveHeight: true,
                prevArrow: '#acc_prev_slick_gallery2',
                nextArrow: '#acc_next_slick_gallery2',
            });
        })

    }

    if ( $('.acc_view_more').length > 0 ) {
        $('.acc_view_more').on( "click", function() {
            $(this).closest('.acc_property').find('.acc_more').slideToggle( 400 , function(){
               if ( $(this).closest('.acc_property').find('.acc_more').css('display') == 'none' ) {
                   $(this).closest('.acc_property').find('.acc_view_more .btn').html('VER MÁS');
               }
               else {
                   $(this).closest('.acc_property').find('.acc_view_more .btn').html('MENOS');
               }
            });
        });
    }

    function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let original_doc = "";

    if ( $('.acc_check_form').length > 0 ){
        $('.acc_check_form').on( "click", function( ev ) {
            const is_submited = getCookie("submittedform");
            if ( is_submited != 'true' ){
                ev.preventDefault();
                original_doc = $(this).prop('href');
                $('*[data-bs-target="#acc_contact_modal"]').click();
            }
        });
    }

    document.addEventListener( 'wpcf7submit', function( event ) {
        const d = new Date();
        d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = "submittedform=true;" + expires + ";path=/";
        if ( original_doc != "" ){
            window.open(original_doc, "_blank");
        }


    }, false );

});


